class MenuShading {
    constructor(element) {
        this.el = element; 

        this.init();
    }

    init() {
        this.setupClickListeners();
    }

    setupClickListeners() {
        const listItems = this.el.querySelectorAll('.accordion-item__button'); 

        listItems.forEach((item, clickedIndex) => {
            item.addEventListener('click', () => {
                setTimeout(() => {
                    this.updateShading(clickedIndex);
                }, 0);
            });
        });
    }

    updateShading(clickedIndex) {
        const listItems = this.el.querySelectorAll('.accordion-item__button');
        const expandedItems = Array.from(listItems).filter(item => item.getAttribute('aria-expanded') === 'true');
        if (expandedItems.length === 0) {
            this.resetShades();
        } else {
            this.applyShades(clickedIndex);
        }
    }

    applyShades(clickedIndex) {
        const listItems = this.el.querySelectorAll('.accordion-item-toggle');
        const maxShade = 90;
        const step = 12; 
        let shade = maxShade;

        listItems.forEach((item, index) => {
            if (index === clickedIndex) {
                item.style.color = "#fff"; 
            } else {
                item.style.color = `hsl(0, 0%, ${shade}%)`;
                shade -= step; 
                shade = Math.max(10, shade);
            }
        });
    }

    resetShades() {
        const listItems = this.el.querySelectorAll('.accordion-item-toggle');
        listItems.forEach((item) => {
            item.style.color = "#fff";
        });
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const navElement = document.querySelector('.site-header-overlay__main .accordion__items');

    if (navElement) {
        new MenuShading(navElement);
    }
});
